import LessonDailyActivities from './component'
export default LessonDailyActivities
